export const mockData = {
  name: "Kartik Shrivastava",
  taglines: [
    "I build, ship, and grow software products.",
    'Back in school, my favorite class was "work experience". It was my chance to present the things I built at home, like an RC car with water-bottle wheels, a bamboo table lamp that my grandad and I hand-sawed, a ship made up of thermocol, an airplane with a talcum powder bottle fuselage (which unfortunately didnt fly) and many more...',
    "These days, I've traded water bottles, dc motors, bamboo and ice cream sticks for code. I build software for living and I absolutely love it.",
    "I'm also on a solo-leveling journey to level myself up in various aspects of life and share what I learn along the way :)",
  ],
  bio: "My routine till Sep 2030 - find unsolved problem in a niche, build, solve and repeat. First problem - Comic creation for everyday people. Project ComicBanana. I believe in learning by building and building with like-minded people.",
  social: {
    github: "https://github.com/ark-tik",
    twitter: "https://x.com/IndieKartik",
    linkedin: "https://www.linkedin.com/in/shrivastava-kartik/",
    // twitch: "https://www.twitch.tv/kartik4ever",
  },
  timeline: [
    {
      year: "Aug 2026 - Present",
      title: "Indie Hacker",
      company: "ChoiceMage",
      logo: "https://cdn.choicemage.com/lp/choice-mage-logo.webp",
      description:
        "A Shopify app designed to uplift sales through engagement. It is an RPG-style quiz that recommends products through gamified conversations with an AI character.",
      links: [
        {
          text: "Website",
          url: "https://choicemage.com",
        },
      ],
    },
    {
      year: "Dec 2025 - Present",
      title: "Indie Hacker",
      company: "Comic Banana",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/kcgx3ew1_image.png",
      description:
        "Creating a tool for storytellers to express their stories using comics. Building Comic Banana to make comic creation accessible for everyday people.",
      links: [
        {
          text: "Website",
          url: "https://comicbanana.com",
        },
      ],
    },
    // {
    //   year: "Jul 2025 - Present",
    //   title: "Senior Software Engineer",
    //   company: "PushOwl",
    //   duration: "9 months",
    //   logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/8vqz47f2_image.png",
    //   description:
    //     "Transitioned to a new role leading the development of a new product - a platform for creating landing pages and advertorials for Shopify merchants. Building tools to help merchants create high-converting pages without technical expertise.",
    //   links: [],
    // },
    {
      year: "Feb 2023 - Jul 2026",
      title: "Software Engineer",
      company: "PushOwl",
      duration: "3 years 2 months",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/8vqz47f2_image.png",
      description:
        "In 2026 I transitioned to a new role leading the development of a new product - building an AI tool to help Shopify merchants publish high-converting landing pages without technical expertise.",
      description2:
        "Between 2024-2025 I was the owner of billing and pricing systems. Refactored billing engine with clear abstractions for future scalability, fortified backend for 2023 Black Friday traffic surges, and contributed to infrastructure upgrades to newer Kubernetes versions.",
      links: [],
    },
    {
      year: "Jun 2022 - Sep 2022",
      title: "Open Source Contributor",
      company: "Google Summer of Code - The ENIGMA Team",
      duration: "4 months",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/23cez9ai_image.png",
      description:
        "Enhanced Interoperability: Designed and implemented deserializers to integrate Enigma game engine with Tiled level editor. Utilized Google Protocol Buffers to encode data and manage schema evolution. Fixed build issues for cross-platform compatibility.",
      links: [
        {
          text: "Project: Tiled Compatibility",
          url: "https://github.com/enigma-dev",
        },
      ],
    },
    {
      year: "Jul 2021 - Mar 2022",
      title: "Indie Hacker",
      company: "Dietitian Near Me",
      duration: "9 months",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/ihsz8xfj_image.png",
      description:
        'A self-funded project based on my personal struggle to maintain good health. Created a platform to bring "people who want to be healthy" and expert Registered Dietitians together. Developed an Android app with real-time chat, nutrition tracking, and photo food journaling. Connected with over 15 talented Registered Dietitians. Currently in the back-burner with new ideas in progress.',
      links: [
        {
          text: "Web Archive (App Store)",
          url: "https://web.archive.org/web/20211230133058/https://play.google.com/store/apps/details?id=com.vyomaan.dietitiannearme",
        },
      ],
      images: [
        "https://customer-assets.emergentagent.com/job_cff55c46-1a8e-48c9-9a48-ea231ac23a62/artifacts/7blv720q_image.png",
        "https://customer-assets.emergentagent.com/job_cff55c46-1a8e-48c9-9a48-ea231ac23a62/artifacts/5i4qj1zs_image.png",
        "https://customer-assets.emergentagent.com/job_cff55c46-1a8e-48c9-9a48-ea231ac23a62/artifacts/5xs4u1i8_image.png",
      ],
    },
    {
      year: "Jul 2020 - Jul 2021",
      title: "Computer Graphics Research Engineer",
      company: "Viga Entertainment Technology",
      duration: "1 year 1 month",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/ku4mzkq2_image.png",
      description:
        "Collaborated with talented computer graphics professionals to develop desktop application for real-time facial expression capture. Partnered with graphics and hardware teams to design light stage for capturing dense facial meshes. Contributed to point cloud triangulation, facial mesh deformation, and research on visualization projects using OpenCV and OpenGL/Vulkan.",
      links: [],
    },
    {
      year: "Jan 2020 - Jun 2020",
      title: "Computer Graphics Engineering Intern",
      company: "Viga Entertainment Technology",
      duration: "6 months",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/ku4mzkq2_image.png",
      description:
        "Worked as a programmer with computer graphics engineers and artists to solve problem statements in real-time film making and GPU intensive tasks. Worked on a POC of geofences for Dubai Expo 2020.",
      links: [],
    },
    {
      year: "Jun 2018 - Aug 2018",
      title: "AR/VR Development Intern",
      company: "Scanta Inc.",
      duration: "3 months",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/fqzh1aw6_image.png",
      description:
        "Collaborated in the development of AR app Pikamoji for ARCore supported devices. Worked on a virtual reality portals demo mobile app.",
      links: [],
    },
    {
      year: "Apr 2017 - May 2018",
      title: "Indie Game Developer",
      company: "TechGeekFreax",
      duration: "1 year 2 months",
      logo: "https://customer-assets.emergentagent.com/job_tech-odyssey-5/artifacts/eaxg94ow_image.png",
      description:
        "Started game development as a medium to learn programming and software development life cycle. Developed two mobile games (Wiggly Spaceship and Bolong) for Android devices during college days. This is where I truly started loving building things and began my programming journey.",
      links: [
        {
          text: "Google Play Developer Profile",
          url: "https://play.google.com/store/apps/dev?id=7045256953733001733",
        },
      ],
    },
  ],
  projects: [
    {
      name: "vs-code-music-visualiser",
      description:
        "VS Code extension to visualize music right inside your code. Brings a unique visual experience to your coding environment.",
      tech: ["TypeScript", "VS Code API"],
      stars: 4,
      link: "https://github.com/ark-tik/vs-code-music-visualiser",
      installs: "289 installs on VS Code Marketplace",
    },
    {
      name: "unity-screen-recorder-krtk",
      description:
        "Record any Android device screen with internal audio and output to .mp4 file in a Unity built app.",
      tech: ["Java", "Unity", "Android"],
      stars: 9,
      link: "https://github.com/ark-tik/unity-screen-recorder-krtk",
    },
    {
      name: "ProceduralMeshGenerator",
      description:
        "OpenGL based 3D human model manipulation project. Experimental work in procedural mesh generation and real-time rendering.",
      tech: ["C++", "OpenGL", "3D Graphics"],
      stars: 2,
      link: "https://github.com/ark-tik/ProceduralMeshGenerator",
    },
    {
      name: "3d-Audio-Visualizer-P3D",
      description:
        "Prototype of a 3D audio visualizer made with Processing 3, producing spectacular visuals from any audio waveform.",
      tech: ["Processing", "Audio Processing", "3D"],
      stars: 3,
      link: "https://github.com/ark-tik/3d-Audio-Visualizer-P3D",
    },
    {
      name: "Code2Gui",
      description:
        "Fastest tool to convert C++ code to GUI in Visual Studio. Simplifying the development workflow.",
      tech: ["C++", "Visual Studio"],
      stars: 0,
      link: "https://github.com/ark-tik/Code2Gui",
    },
    {
      name: "AR_Outdoor_Ads",
      description:
        "AR Ads Unity project demo exploring the future of advertising by replacing traditional printed ads with augmented reality experiences.",
      tech: ["C#", "Unity", "AR"],
      stars: 0,
      link: "https://github.com/ark-tik/AR_Outdoor_Ads",
    },
  ],
  favorites: {
    podcast: [
      {
        name: "Founders Podcast",
        by: "David Senra",
        icon: "🎙️",
        link: "https://www.youtube.com/@founderspodcast1",
      },
      {
        name: "Diary of a CEO",
        by: "Steven Bartlett",
        icon: "🎙️",
        link: "https://open.spotify.com/show/7iQXmUT7XGuZSzAMjoNWlX",
      },
    ],
    manga: [
      {
        name: "One Piece",
        icon: "📖",
        link: "https://www.viz.com/shonenjump/chapters/one-piece",
      },
      {
        name: "Solo Leveling",
        icon: "📖",
        link: "https://solo-leveling.fandom.com/wiki/Solo_Leveling_Wiki",
      },
    ],
    book: [
      {
        name: "Hard Drive by James Wallace",
        icon: "📚",
        link: "https://www.google.co.in/books/edition/Hard_Drive/4JW1AAAAIAAJ",
      },
      {
        name: "Designing Data-Intensive Applications by Martin Kleppmann",
        icon: "📚",
        link: "https://www.google.co.in/books/edition/Designing_Data_Intensive_Applications/zFheDgAAQBAJ",
      },
      {
        name: "The Courage to Be Disliked by Ichiro Kishimi, Fumitake Koga",
        icon: "📚",
        link: "https://www.google.co.in/books/edition/The_Courage_To_Be_Disliked/IggxDwAAQBAJ",
      },
    ],
  },
};
